module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMy4zMzMiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMy4zMzMgMTYiPgogIDxwYXRoIGlkPSJJY29uX2lvbmljLW1kLWRvd25sb2FkIiBkYXRhLW5hbWU9Ikljb24gaW9uaWMtbWQtZG93bmxvYWQiIGQ9Ik0yMC4wODMsMTAuMTQ2SDE2LjI3NVY0LjVIMTAuNTU4djUuNjQ2SDYuNzVsNi42NjcsNi41ODdaTTYuNzUsMTguNjE3VjIwLjVIMjAuMDgzVjE4LjYxN1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02Ljc1IC00LjUpIiBmaWxsPSIjMmU3YjgwIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico_download.svg
// module id = 3PJU
// module chunks = 1